var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_446_56",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_446_56",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABmJLR0QA/wD/AP+gvaeTAAACW0lEQVRoge2ZO4sUQRRGz/W5Bj5WAxVWM1lY0TWQxUAQwUQQjP0poj/ARPwBhka6gmAiCosswsqKoKiJsAi+QlF7wRfIZ9CjzM5Md5dWddfYXQc66blzq85UU7duDyQSiUQikRhrJO2TdFNSpvEjk3RL0rSLi7nIAk+Bnb4/XM18BGbN7G1Z0DqHRFcYf1mASeByVZDLCmfA1hAzaoDMzLaXBbgIK9x86sfMSp1cHulW0TnhDYHyLAELwBbgLHAgUN7mcaiDFyRZX/yEpPm6im4VVT6+m9Yj4JiZrYmRtAN4DWyryh+aujet+4OyvUE/AY89c9eCr3BZfS6th7HwFT4jaUha0kHgsGfuWvAV3g9cl7T79w1Jh4B5YKNn7loIddL6CjwnL0szwHrPef0zVZtW546WoQ4eIVgFloFXwE9gL3AUmGp0Fg61fmgfkLRnIOZqQe57kr5LOi9paFeXZJJOSHoR6uARe4W/AafM7MGoD3s1flHSHLBIvuJexG4eLhbJ9mNmX4Bz5I+6F1GFzezZX8SuALd9x4y9wsCfhmOud20uCb3jO1Z0YUmngffkO/QysCJppiD8ie94UYUlbQKusfYl4RRwqeArb3zHjL3CJ4FdI+4fV1+P3cdn3wFjCxe9GZnsXYP8ALxOfrGFy1rIicEbvbr8XwuXHXxqaUBiCzdOEm47SbjtJOG20znhzr3E69wKJ+G24yK8WvsswlHZL7sILwSYSFPcrQpw2aWngYeMbsjHiQ/AETN7VxZUucJm9hKYJf9HMAszt6BkwA0cZBOJRCKRSMTlF/F6QhMyL3FPAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.dceab2e27a95242b706efcab1d6caed5.svg";
export { ForwardRef as ReactComponent };